import type {Article, ArticleApi, ArticlesApiResponse} from "./news.types";

export const slugify = (title: string): string =>
  title
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");

export const adaptArticle = (api: ArticleApi): Article => {
  const title = api.title ?? "Artículo";
  return {
    id: String(api.id ?? ""),
    title,
    excerpt: api.excerpt ?? "",
    image: api.cover ?? api.image ?? null,
    content: api.content ?? null,
    createdAt: api.created_at ?? api.createdAt ?? "",
    slug: api.slug ?? slugify(title),
  };
};

export const adaptArticles = (response: ArticlesApiResponse): Article[] => {
  const list = response?.data?.data?.articles;
  if (!Array.isArray(list)) return [];
  return list.map(adaptArticle);
};
